/* eslint-disable arrow-body-style */
import moment, { Moment } from 'moment';
// import { shortcutOptionItemType } from '../_type';

// 定义接口
export interface DateShortcutType {
  name: string;
  type: string;
  nameCN: string;
  onClick: () => Array<Moment | null>;
}

export interface ShortcutOptionType {
  [type: string]: DateShortcutType[];
}


// startOfTime和latestDate，不是所有地方都需要，需要从外部传入参数
export const getExtraShortcut = (seasonInfo: any): ShortcutOptionType => {
  // const setFilterSaveDurationFunc = (data: shortcutOptionItemType) => {
  //   dispatch({
  //     type: 'dashboardSetting/setFilterSaveDuration',
  //     payload: {
  //       data: data,
  //     },
  //   });
  // }

  const getSessionValue = (seasonInfoArr: any[], type: string) => {
    return seasonInfoArr?.map((item, index) => {
      const { event_type_name_en: eventTypeNameEn, name, nameCN, start_date: startDate, end_date: endDate } = item || {};
      return {
        name: name || '',
        nameCN: nameCN || '',
        // type: `${type}_${item?.name?.replace(/\s+/g, '')}`,
        // 后端反馈没有事件id，也无法做id，所以这里前端type做处理给一个唯一的type
        type: `${type}_${name?.replace(/\s+/g, '')}_${eventTypeNameEn}_${index}`,
        event_id: `${eventTypeNameEn}_${name?.replace(/\s+/g, '')}_${startDate}_${endDate}`,
        timeType: type,
        value: [moment(startDate), moment(endDate)],
        ...(item || {}),
        onClick: () => {
          // setFilterSaveDurationFunc({
          //   name: item?.name || '',
          //   nameCN: item?.nameCN || '',
          //   type: `${type}_${item?.name?.replace(/\s+/g, '')}_${item?.event_type_name_en}__${index}`,
          // })
          return [moment(startDate), moment(endDate)];
        }
      };
    }) || [];
  };

  const seasonInfoHour = getSessionValue(seasonInfo?.hour, 'hour');
  const seasonInfoDate = getSessionValue(seasonInfo?.date, 'date');
  const seasonInfoWeek = getSessionValue(seasonInfo?.week, 'week');
  const seasonInfoMonth = getSessionValue(seasonInfo?.month, 'month');

  return {
    'hour': seasonInfoHour,
    'date': seasonInfoDate,
    'week': seasonInfoWeek,
    'month': seasonInfoMonth,
  };
};
